/** 已通过项目发起变更时，列表模块显示「状态」列（与思政微课 teamInfo 一致） */
export default {
  props: {
    showChangeStatus: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isApplyPassed() {
      if (this.showChangeStatus) return true;
      return String(this.resolveEditInfo().auditState) === "2";
    },
  },
  methods: {
    resolveEditInfo() {
      if (this.oldInfos && (this.oldInfos.auditState != null || this.oldInfos.id)) {
        return this.oldInfos;
      }
      let p = this.$parent;
      for (let i = 0; i < 5 && p; i++) {
        if (p.editInfo) return p.editInfo;
        p = p.$parent;
      }
      return this.oldInfos || {};
    },
    shouldShowListChangeStatus() {
      const role = this.$store.state.role;
      return (
        this.oldInfos &&
        this.oldInfos.id &&
        this.isApplyPassed &&
        (role === "school-role" || role === "teacher-role")
      );
    },
    ensureStatusColumn(baseColumns) {
      const cols = baseColumns || [];
      if (this.shouldShowListChangeStatus()) {
        const titleExists = (this.columns || []).some((column) => column.title === "状态");
        this.isstatus = true;
        this.pagination = false;
        if (!titleExists) {
          const statusCol = {
            title: "状态",
            dataIndex: "status",
            id: "status",
            align: "center",
            scopedSlots: { customRender: "status" },
            width: 80,
            customCell: () => ({
              style: { padding: "0", position: "relative" },
            }),
          };
          this.columns = [statusCol, ...cols.filter((item) => item.title !== "状态")];
        }
      } else {
        this.isstatus = false;
        this.columns = cols.filter((item) => item.title !== "状态");
      }
    },
  },
};
